// extracted by mini-css-extract-plugin
module.exports = {"ellipsis":"styles_ellipsis__etqqV","base":"styles_base__p5N01","breakWord":"styles_breakWord__2xXAN"};